import { selectionSliderManager } from '@molecules/selection-slider-manager';
import { favoriteButton } from '@pages/offer-page/selection/favorite-button';
import { proposalButton } from '@pages/offer-page/selection/proposal-button';
import { refuseProposalButton, selectionItemRemoveListener } from '@pages/offer-page/selection/refuse-proposal-button';

export const selection = () => {
  selectionSliderManager();

  document.querySelectorAll('[data-offer-favorite-button="on"]').forEach(
    (button) => favoriteButton(button),
  );

  document.querySelectorAll('[data-offer-proposal-button="on"]').forEach(
    (button) => proposalButton(button),
  );

  document.querySelectorAll('[data-offer-refuse-proposal-button="on"]').forEach(
    (button) => refuseProposalButton(button),
  );

  if (document.querySelector('[data-offer-refuse-proposal-button="on"]')) {
    selectionItemRemoveListener();
  }
};
